import React, { useEffect, useState } from 'react';
import "./OnlineForm.css";
import { FormTrash } from 'grommet-icons';
import InputGroupAddon from 'rsuite/esm/InputGroup/InputGroupAddon';
import FormSubmit from '../../../../../services/form/formSubmit';
import { Button, Select, TextInput } from 'grommet';
import { useStore } from '../../../../../Hooks/useStore';
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from "react-router-dom";
import usersService from '../IAM/Users/users.service';

const OnlineForm = () => {
    const { rootStore } = useStore();
    const navigate = useNavigate();
    const [phoneNumberArray, setPhoneNumberArray] = useState([
        { id: 1, value: "" }
    ]);
    const [emailArray, setEmailArray] = useState([
        { id: 1, value: "" }
    ]);
    const [crewMemArr1, setCrewMemArr1] = useState([
        { id: 1, firstname: "", lastName: "", genderIdentity: "", email: "" }
    ]);
    // const [crewMemArr2, setCrewMemArr2] = useState([
    //     {id: 1, firstname: "", lastName: "", genderIdentity: "", email: ""}
    // ]);
    const [airInfoArr1, setAirInfoArr] = useState([
        { id: 1, Reg: "", msn: "", fleetType: "", wifiPro: "" }
    ]);
    const [allFlights, setAllFlights] = useState([]);
    const [showAllFlights, setShowAllFlights] = useState(false);
    const [fliteredFlightList, setFilteredFlightList] = useState([])
    const [allWifiProvider, setAllWifiProvider] = useState([]);
    const [showAllWifiProvider, setShowAllWifiProvider] = useState(false);
    const [filteredWifiProvider, setFilteredWifiProvider] = useState([]);
    const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

    
    const deleteEmailField = (deleteId) => {
        setEmailArray(emailArray.filter((_, index) => _.id !== deleteId));
    }

    const deletePhoneNumField = (deleteId) => {
        setPhoneNumberArray(phoneNumberArray.filter((_, index) => _.id !== deleteId));
    }

    const deleteCrewMem1Field = (deleteId) => {
        setCrewMemArr1(crewMemArr1.filter((_, index) => _.id !== deleteId));
    }

    // const deleteCrewMem2Field = (deleteId) => {
    //     setCrewMemArr2(crewMemArr2.filter((_, index) => _.id !== deleteId));
    // }

    const deleteAirInfoField = (deleteId) => {
        setAirInfoArr(airInfoArr1.filter((_, index) => _.id !== deleteId));
    }

    const airInfoChange = (id, columnName, e) => {
        const { value } = e.target;
        setAirInfoArr((prevState) =>
            prevState.map((item) =>
                item.id === id ? { ...item, [columnName]: value } : item
            )
        );
    };

    // const crewMem2Change = (id, columnName, e) => {
    //     const { value } = e.target; // Get the value from the input
    //     setCrewMemArr2((prevState) =>
    //         prevState.map((item) =>
    //             item.id === id ? { ...item, [columnName]: value } : item
    //         )
    //     );
    // };

    const crewMem1Change = (id, columnName, e) => {
        const { value } = e.target; // Get the value from the input
        setCrewMemArr1((prevState) =>
            prevState.map((item) =>
                item.id === id ? { ...item, [columnName]: value } : item
            )
        );
    };

    const changeEmail = (id, e) => {
        const { value } = e.target; // Get the value from the input
        setEmailArray((prevState) =>
            prevState.map((item) =>
                item.id === id ? { ...item, value: value } : item
            )
        );
    }

    const changePhoneNum = (id, e) => {
        const { value } = e.target; // Get the value from the input
        setPhoneNumberArray((prevState) =>
            prevState.map((item) =>
                item.id === id ? { ...item, value: value } : item
            )
        );
    }
    const [leagalEntityName, setLegalEntityName] = useState("");
    const [address, setAddress] = useState("");
    const [userInfo, setUserInfo] = useState("");
    const [activeTdIndex, setActiveTdIndex] = useState(null);

    function onChange(value) {
        setIsCaptchaVerified(true)
    };
    const handleExpired = () => {
        setIsCaptchaVerified(false)
    };    

    const formSubmit = async () => {
        try {
            rootStore.loadingStore.setShowLoader(true)
            const res = await FormSubmit.createSubmitForm(leagalEntityName, address, emailArray, phoneNumberArray, crewMemArr1, airInfoArr1, userInfo);
            if (res.status === 201) {
                rootStore.notificationToastStore.showNotification(
                    "Form submitted successfully",
                    false,
                    3000
                );
                rootStore.loadingStore.setShowLoader(false);
            }
            if (!localStorage.getItem("userinfo")) {
                alert("Form submitted successfully")
            }
            setLegalEntityName("");
            setAddress("");
            setUserInfo("");
            setPhoneNumberArray([{ id: 1, value: "" }]);
            setEmailArray([{ id: 1, value: "" }]);
            setCrewMemArr1([{ id: 1, firstname: "", lastName: "", genderIdentity: "", email: "" }]);
            setAirInfoArr([{ id: 1, Reg: "", msn: "", fleetType: "", wifiPro: "" }]);
            setFilteredFlightList(allFlights);
            setFilteredWifiProvider(allWifiProvider);
            navigate("/submittedforms");
        } catch (err) {
            rootStore.notificationToastStore.showNotification(
                "Failed to submit form. Please try again later.",
                true,
                3000
            );
            rootStore.loadingStore.setShowLoader(false);
        }

    }

    useEffect(() => {
        async function fetchFlights() {
            const flightList = await FormSubmit.getAllFlightsWithoutLogin();
            const wifiProvider = await FormSubmit.getWifiProviderWithoutLogin();
            setAllFlights(flightList);
            setFilteredFlightList(flightList);
            setAllWifiProvider(wifiProvider);
            setFilteredWifiProvider(wifiProvider);
        };
        fetchFlights();
    }, []);



    const GENDER_OPTIONS = [
        {
            label: "Male",
            value: "male",
        },
        {
            label: "Female",
            value: "female",
        },
        {
            label: "Others",
            value: "others",
        },
    ];

    return (
        <div className='form-container'>
            {/* <h2 className='heading'>Appendix A</h2> */}
            <h2 className='heading'>SERVICE START NOTIFICATION</h2>
            <p className='form-description'>
                This is to notify you of the commencement of services by Skali Inc. Please populate this form with the required information.
                Please note that all information provided in this form is deemed confidential and will not be disclosed externally without the approved
                written consent of the sending organization.
            </p>
            <h3 className='sub-heading'>ORGANIZATION INFORMATION</h3>
            <table className='form-table first'>
                <tbody>
                    <tr>
                        <th>LEGAL ENTITY NAME</th>
                        <td><input placeholder='type here' type='text' value={leagalEntityName} onChange={(e) => setLegalEntityName(e.target.value)} /></td>
                    </tr>
                    <tr>
                        <th>ADRESS</th>
                        <td><input placeholder='type here' type='text' value={address} onChange={(e) => setAddress(e.target.value)} /></td>
                    </tr>
                    <tr>
                        <th>PHONE NUMBER</th>
                        <td>
                            {
                                phoneNumberArray.map((item, index) => {
                                    return (
                                        <div key={item.id}>
                                            <div className='input-main'>
                                                <input onChange={(e) => changePhoneNum(item.id, e)} value={item.value} placeholder='type here' type='text' />
                                                {index > 0 && <FormTrash color="red" onClick={() => deletePhoneNumField(item.id)} className='delete-icon' />}
                                            </div>
                                            {
                                                index == phoneNumberArray.length - 1 && <div className='add-icon-container'>
                                                    {/* <p className='add-row-btn' onClick={() => setPhoneNumberArray([...phoneNumberArray, {id: phoneNumberArray.length + 1, value: ""}])}> */}
                                                    <Button
                                                        style={{ fontSize: "x-small", backgroundColor: "#3A82FB", color: "white" }}
                                                        label="Add Another"
                                                        onClick={() => setPhoneNumberArray([...phoneNumberArray, { id: phoneNumberArray.length + 1, value: "" }])}
                                                    />
                                                    {/* </p> */}
                                                </div>
                                            }
                                        </div>
                                    )
                                })
                            }
                        </td>
                    </tr>
                    <tr>
                        <th>EMAIL</th>
                        <td>
                            {
                                emailArray.map((item, index) => {
                                    return (
                                        <div key={item.id}>
                                            <div className='input-main'>
                                                <input placeholder='type here' onChange={(e) => changeEmail(item.id, e)} value={item.value} type='text' />
                                                {index > 0 && <FormTrash color="red" onClick={() => deleteEmailField(item.id)} className='delete-icon' />}
                                            </div>
                                            {
                                                index == emailArray.length - 1 && <div className='add-icon-container'>
                                                    {/* <p className='add-row-btn' onClick={() => setEmailArray([...emailArray, {id: emailArray.length + 1, value: ""}])}>+</p> */}
                                                    <Button
                                                        style={{ fontSize: "x-small", backgroundColor: "#3A82FB", color: "white" }}
                                                        label="Add Another"
                                                        onClick={() => setEmailArray([...emailArray, { id: emailArray.length + 1, value: "" }])}
                                                    />
                                                </div>
                                            }
                                        </div>
                                    )
                                })
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
            <h3 className='sub-heading bold-heading'>CREW INFORMATION</h3>
            <p className='sub-heading-description'>
                Please provide the following information for all flight cabin crew members
                who will be operating aircraft with Skali equipped EFBs and Skali, Inc provided
                medical kits. Information will be kept confidential and will not be shared with anyone outside of
                Skali, Inc or your organization.
            </p>
            <table className='form-table second'>
                <thead>
                    <tr>
                        <th style={{ textAlign: "center" }} colSpan={4}>FLIGHT CREW MEMBER</th>
                    </tr>
                    <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Gender Identity</th>
                        <th>Email</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        crewMemArr1.map((item, index) => {
                            return (
                                <tr key={item.id}>
                                    <td><input onChange={(e) => crewMem1Change(item.id, "firstname", e)} value={item.firstname} type='text' /></td>
                                    <td><input onChange={(e) => crewMem1Change(item.id, "lastName", e)} value={item.lastName} type='text' /></td>
                                    {/* <td><input onChange={(e) => crewMem1Change(item.id, "genderIdentity", e)} value={item.genderIdentity} type='text' /></td> */}
                                    <td className='no-border-button'>
                                        <Select
                                            className="add-user-select select"
                                            style={{ margin: "0px" }}
                                            name="gender"
                                            labelKey={"label"}
                                            valueKey={{ key: "value", reduce: true }}
                                            options={GENDER_OPTIONS}
                                            placeholder="Select"
                                            defaultValue={""}
                                            value={item.genderIdentity}
                                            onChange={(e) => crewMem1Change(item.id, "genderIdentity", e)}
                                        />
                                    </td>
                                    {/* <td><input onChange={(e) => crewMem1Change(item.id, "email", e)} style={{ marginTop: "8px" }} value={item.email} type='text' />{index !== 0 && <FormTrash color="red" className='delect-row' onClick={() => deleteCrewMem1Field(item.id)} />}</td> */}
                                    <td>
                                        <div style={{ display: 'flex', alignItems: 'center', width: "100%" }}>
                                            <input
                                                onChange={(e) => crewMem1Change(item.id, "email", e)}
                                                style={{ marginTop: "8px" }}
                                                value={item.email}
                                                type='text'
                                            />
                                            {index !== 0 && (
                                                <FormTrash
                                                    color="red"
                                                    onClick={() => deleteCrewMem1Field(item.id)}
                                                    style={{ marginLeft: '10px' }}
                                                />
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            )
                        })

                    }

                </tbody>
            </table>
            <div className='add-icon-container'>
                {/* <p className='add-row-btn' onClick={() => setCrewMemArr1([...crewMemArr1, { id: crewMemArr1.length + 1, firstname: "", lastName: "", genderIdentity: "", email: "" }])}>+</p> */}
                <Button
                    style={{ fontSize: "x-small", backgroundColor: "#3A82FB", color: "white", marginTop: "5px" }}
                    label="Add Another"
                    onClick={() => setCrewMemArr1([...crewMemArr1, { id: crewMemArr1.length + 1, firstname: "", lastName: "", genderIdentity: "", email: "" }])}
                />
            </div>

            {/* <table className='form-table second'>
                <thead>
                    <tr>
                        <th style={{textAlign: "center"}} colSpan={4}>CABIN CREW MEMBER</th>
                    </tr>
                    <tr>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Gender Identity</th>
                        <th>Email</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        crewMemArr2.map((item, index) => {
                            return (
                                <tr key={item.id}>
                                    <td><input onChange={(e) => crewMem2Change(item.id, "firstname", e)} type='text' value={item.firstname} /></td>
                                    <td><input onChange={(e) => crewMem2Change(item.id, "lastName", e)} type='text' value={item.lastName} /></td>
                                    <td><input onChange={(e) => crewMem2Change(item.id, "genderIdentity", e)} type='text' value={item.genderIdentity} /></td>
                                    <td><input onChange={(e) => crewMem2Change(item.id, "email", e)} type='text' value={item.email} />{index !== 0 && <FormTrash color="red" className='delect-row' onClick={() => deleteCrewMem2Field(item.id)} />}</td>
                                </tr>
                            )
                        })

                    }

                </tbody>
            </table>
            <div className='add-icon-container'><p className='add-row-btn' onClick={() => setCrewMemArr2([...crewMemArr2, {id: crewMemArr2.length + 1, firstname: "", lastName: "", genderIdentity: "", email: ""}])}>+</p></div> */}



            <h3 className='sub-heading bold-heading'>AIRCRAFT INFORMATION</h3>
            <p className='sub-heading-description'>
                Please provide the following information for all aircraft which you intend to operate Skali equipped EFBs and Skali, Inc provided medical kits.
                {/* Also please provide any typical route data commonly flown by your organization. */}
                This information is considered confidential and will not be shared
                externally without the expressed written consent of your organization.
            </p>
            <table className='form-table second'>
                <thead>
                    <tr>
                        <th style={{ textAlign: "center" }} colSpan={4}>AIRCRAFT INFORMATION</th>
                    </tr>
                    <tr>
                        <th>Registration (Ex. N12345)</th>
                        <th>MSN</th>
                        <th>Fleet Type (Ex. 737-400)</th>
                        <th>Wi-Fi Provider (Ex. Gogo)</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        airInfoArr1.map((item, index) => {
                            return (
                                <tr key={item.id}>
                                    <td><input onChange={(e) => airInfoChange(item.id, "Reg", e)} value={item.Reg} type='text' /></td>
                                    <td><input onChange={(e) => airInfoChange(item.id, "msn", e)} value={item.msn} type='text' /></td>
                                    {/* <td><input onChange={(e) => airInfoChange(item.id, "fleetType", e)} value={item.fleetType} type='text' /></td> */}
                                    {/* <td className='no-border-button'>
                                    <Select
                                        className="add-user-select select"
                                        style={{margin:"0px"}}
                                        name="gender"
                                        labelKey={"airCraftType"}
                                        valueKey={{ key: "airCraftType", reduce: true }}
                                        options={allFlights}
                                        placeholder="Select"
                                        defaultValue={""}
                                        value={item.fleetType}
                                        onChange={(e) => airInfoChange(item.id, "fleetType", e)}
                                    />
                                    </td> */}
                                    <td>
                                        <div style={{ position: "relative" }}>
                                            <TextInput className="name_input" type="text" placeholder="Enter here" value={item.fleetType} onChange={(e) => {
                                                airInfoChange(item.id, "fleetType", e);
                                                if (e.target.value.trim() !== "") {
                                                    const filteredList = allFlights.filter((item) => item.airCraftType && item.airCraftType.toLowerCase().includes(e.target.value.toLowerCase()));
                                                    setFilteredFlightList(filteredList)
                                                } else {
                                                    setFilteredFlightList(allFlights)
                                                }
                                            }} style={{ height: "48px" }} onClick={() => {
                                                setActiveTdIndex(index);
                                                setShowAllFlights(true);
                                            }} onBlur={() => {
                                                setTimeout(() => {
                                                    setShowAllFlights(false)
                                                }, 500);
                                            }} />
                                            {/*
                                            {activeTdIndex === index && showAllFlights &&
                                                (<div className="passenger-exist-box">
                                                    <ul>
                                                        {fliteredFlightList.map(flight => {
                                                            return <li
                                                                key={flight.id}
                                                                onClick={(e) => {
                                                                    item.fleetType = flight.airCraftType
                                                                    setShowAllFlights(false)
                                                                }}
                                                            >{flight.airCraftType}</li>
                                                        })}
                                                    </ul>
                                                </div>)
                                            }
                                            */}
                                        </div>
                                    </td>


                                    {/* <td><input onChange={(e) => airInfoChange(item.id, "wifiPro", e)} value={item.wifiPro} type='text' />{index !== 0 && <FormTrash color="red" className='delect-row' onClick={() => deleteAirInfoField(item.id)} />}</td> */}
                                    {/* <td className='no-border-button'>
                                        <Select
                                            className="add-user-select select"
                                            style={{ margin: "0px" }}
                                            name="gender"
                                            labelKey={"wifiProvider"}
                                            valueKey={{ key: "wifiProvider", reduce: true }}
                                            options={allWifiProvider}
                                            placeholder="Select"
                                            defaultValue={""}
                                            value={item.wifiPro}
                                            onChange={(e) => airInfoChange(item.id, "wifiPro", e)}
                                        />
                                        {index !== 0 && <FormTrash color="red" className='delect-row' onClick={() => deleteAirInfoField(item.id)} />}
                                    </td> */}
                                    <td>
                                        <div style={{ display: 'flex', alignItems: 'center', width: "100%" }}>
                                            <div style={{ position: "relative", width: "100%" }}>
                                                <TextInput className="name_input" type="text" placeholder="Enter here" value={item.wifiPro} onChange={(e) => {
                                                    airInfoChange(item.id, "wifiPro", e);
                                                    if (e.target.value.trim() !== "") {
                                                        const filteredList = allWifiProvider.filter((item) => item.wifiProvider && item.wifiProvider.toLowerCase().includes(e.target.value.toLowerCase()));
                                                        setFilteredWifiProvider(filteredList)
                                                    } else {
                                                        setFilteredWifiProvider(allWifiProvider)
                                                    }
                                                }} style={{ height: "48px" }} onClick={() => {
                                                    setActiveTdIndex(index);
                                                    setShowAllWifiProvider(true)
                                                }} onBlur={() => {
                                                    setTimeout(() => {
                                                        setShowAllWifiProvider(false)
                                                    }, 500);
                                                }} />
                                                {/*
                                                {activeTdIndex === index && showAllWifiProvider &&
                                                    (<div className="passenger-exist-box">
                                                        <ul>
                                                            {filteredWifiProvider.map(wifi => {
                                                                return <li
                                                                    key={wifi.id}
                                                                    onClick={(e) => {
                                                                        item.wifiPro = wifi.wifiProvider
                                                                        setShowAllWifiProvider(false)
                                                                    }}
                                                                >{wifi.wifiProvider}</li>
                                                            })}
                                                        </ul>
                                                    </div>)
                                                }
                                                */}
                                            </div>
                                            {index !== 0 && <FormTrash color="red" onClick={() => deleteAirInfoField(item.id)} />}
                                        </div>

                                    </td>
                                </tr>
                            )
                        })

                    }

                </tbody>
            </table>
            <div className='add-icon-container'>
                {/* <p className='add-row-btn' onClick={() => setAirInfoArr([...airInfoArr1, { id: airInfoArr1.length + 1, Reg: "", msn: "", fleetType: "", wifiPro: "" }])}>+</p> */}
                <Button
                    style={{ fontSize: "x-small", backgroundColor: "#3A82FB", color: "white", marginTop: "5px" }}
                    label="Add Another"
                    onClick={() => {
                        setAirInfoArr([...airInfoArr1, { id: airInfoArr1.length + 1, Reg: "", msn: "", fleetType: "", wifiPro: "" }]);
                        setFilteredFlightList(allFlights);
                        setFilteredWifiProvider(allWifiProvider);
                    }}
                />
            </div>

            <div>
                <h3 className='sub-heading bold-heading'>USER INFORMATION</h3>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div className='user-name-section'>
                        <label>Enter Your Name: </label>
                        <input type='text' value={userInfo} onChange={(e) => setUserInfo(e.target.value)} />
                    </div>
                    <div>
                        <ReCAPTCHA
                            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                            onChange={onChange}
                            onExpired={handleExpired}
                        />
                    </div>
                </div>
            </div>



            <div>
                <Button
                    style={{
                        backgroundColor: "rgb(53, 126, 255)",
                        border: "1px solid rgb(53, 126, 255)",
                        radius: "10px",
                        padding: "12px 28px",
                        color: "#FFF",
                        lineHeight: "16px",
                        marginLeft: "91%",
                        borderRadius: "10px",
                        marginTop: "20px"
                    }}
                    onClick={() => formSubmit()}
                    disabled={leagalEntityName === "" || address === "" || phoneNumberArray[0].value === "" || emailArray[0].value === "" || userInfo === "" || !isCaptchaVerified}
                >
                    Submit
                </Button>
            </div>
        </div>
    );
}

export default OnlineForm;
